import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { authService } from './services/authService';
import { AuthProvider } from './services/AuthContext';
import LoginScreen from './components/LoginScreen';
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import Dashboard from './components/pages/Dashboard';
import Tenants from './components/pages/Tenants';
import TenantDetail from './components/pages/TenantDetail';
import Funds from './components/pages/Funds';
import Providers from './components/pages/Providers';
import AuditLog from './components/pages/AuditLog';
import Settings from './components/pages/Settings';
import ModelTraining from './components/pages/ModelTraining';
import './App.css';

function App() {
    const [authState, setAuthState] = useState({ loading: true, authenticated: false, user: null, message: '' });

    useEffect(() => {
        authService.validateSession().then((result) => {
            setAuthState({
                loading: false,
                authenticated: result.valid,
                user: result.valid ? result.user : null,
                message: result.message || '',
            });
        }).catch((err) => {
            // Never leave the app stuck on the loading spinner — surface the error on the
            // login screen so the cause is visible (MSAL errors carry errorCode/errorMessage).
            // eslint-disable-next-line no-console
            console.error('validateSession failed', err);
            setAuthState({
                loading: false,
                authenticated: false,
                user: null,
                message: `Sign-in failed: ${err?.errorCode || ''} ${err?.errorMessage || err?.message || err}`.trim(),
            });
        });
    }, []);

    const handleLogout = async () => {
        await authService.logout(); // redirects away
    };

    if (authState.loading) {
        return (
            <div className="app-loading">
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (!authState.authenticated) {
        return <LoginScreen message={authState.message} />;
    }

    return (
        <AuthProvider user={authState.user}>
        <BrowserRouter>
            <div className="admin-layout">
                <Header user={authState.user} onLogout={handleLogout} />
                <div className="admin-body">
                    <Sidebar />
                    <main className="admin-main">
                        <Routes>
                            <Route path="/"          element={<Dashboard />} />
                            <Route path="/tenants"   element={<Tenants />} />
                            <Route path="/tenants/:code"      element={<TenantDetail />} />
                            <Route path="/tenants/:code/:tab" element={<TenantDetail />} />
                            <Route path="/providers" element={<Providers />} />
                            <Route path="/funds"     element={<Funds />} />
                            <Route path="/model-training" element={<ModelTraining />} />
                            <Route path="/audit-log" element={<AuditLog />} />
                            <Route path="/settings"  element={<Settings />} />
                        </Routes>
                    </main>
                </div>
            </div>
        </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
